const formInit = function formInit() {
  const zforms = document.querySelectorAll('[data-form]');

  if (!zforms.length) return;

  zforms.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const feedbackEl = form.querySelector('.feedback');
      const formData = new FormData(form);
      console.log(formData);
      fetch(`https://formspree.io/f/${'YOUR_FORM_ID'}`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) =>
          response.json().then((result) => ({ response, result }))
        )
        .then(({ response, result }) => {
          if (response.ok) {
            feedbackEl.innerHTML = `
              <div class="alert alert-success">
                Your message has been sent successfully.
              </div>`;
            form.reset();
          } else {
            feedbackEl.innerHTML = `
              <div class="alert alert-danger">
                ${result.error || 'Something went wrong'}
              </div>`;
          }
        })
        .catch(() => {
          feedbackEl.innerHTML = `
            <div class="alert alert-danger">
              Network error. Please try again.
            </div>`;
        })
        .finally(() => {
          setTimeout(() => {
            feedbackEl.innerHTML = '';
          }, 3000);
        });
    });
  });
};

export default formInit;
